/* unplugin-vue-components disabled */import script from "./Poster.vue?vue&type=script&setup=true&lang=js"
export * from "./Poster.vue?vue&type=script&setup=true&lang=js"

import "./Poster.vue?vue&type=style&index=0&id=25ea61a3&scoped=true&lang=scss"

import exportComponent from "D:\\pangu_artificial_intelligence_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25ea61a3"]])

export default __exports__